import PropTypes from 'prop-types';

import adminImage from '../../../assets/images/admin_image.png'; 
import deliveryImage from '../../../assets/images/delivery_image.png'; 
import agencyImage from '../../../assets/images/agency_image.png'; 

import { grey } from '@mui/material/colors';
import { useMediaQuery, useTheme } from '@mui/material';
import { Container, Dialog, Typography } from '@mui/material';
import { usePermissions } from '../../../hooks/permissions/usePermissions';

UserRolesDialog.propTypes = {
  onClose: PropTypes.func.isRequired,
  onOpenDialog: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
};

export default function UserRolesDialog({ onClose, onOpenDialog, open }) {

  const theme = useTheme();

  const { hasPermission } = usePermissions();

  const rolePermissionsMap = {
    Administrador: 'usr_cra',
    Repartidor: 'usr_crd',
    Sucursal: 'usr_crg'
  };

  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const containerStyle = {
    display: 'flex',
    flexDirection: isMobile ? 'column' : 'row',
    gap: '12px',
    padding: 0,
  };

  const roleImageMap = {
    'Administrador': adminImage,
    'Repartidor': deliveryImage,
    'Sucursal': agencyImage
  };

  const roles = ['Administrador', 'Repartidor', 'Sucursal'];

  const availableRoles = roles.filter(role => hasPermission(rolePermissionsMap[role]));

  return (
    <Dialog onClose={onClose} open={open} PaperProps={{ style: { borderRadius: '16px' } }} >
      <Container style={{ padding: 26 }} >
        <Typography component="div" variant="h5" style={{ textAlign: 'center', fontWeight: 'bold', color: grey[800], marginBottom: 26 }} >
          Elige el tipo de usuario
        </Typography>

        <Container style={containerStyle} >

        {availableRoles.map((role) => (
            <Container 
              key={role} 
              onClick={() => onOpenDialog(role)}
              sx={{
                width: '290px', 
                height: '200px', 
                borderRadius: '0.5rem', 
                backgroundColor: grey[100],
                display: 'flex', 
                flexDirection: 'column', 
                justifyContent: 'center', 
                alignItems: 'center',
                '&:hover': { backgroundColor: grey[200], cursor: 'pointer' }
              }}>
              <img src={roleImageMap[role]} style={{ width: '80px', marginBottom: '12px' }} alt={role} />
              <Typography component="div" variant="h6" style={{ color: grey[800] }}>
                {role}
              </Typography>
            </Container>
          ))}

        </Container>
      </Container>
    </Dialog>
  );
}